import { useQuery } from '@tanstack/react-query';
import { fetchProjectCalendarWeek } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useProjectCalendarEvents = (year: number, calendarWeek: number) =>
  useQuery({
    queryFn: () =>
      extractData(
        fetchProjectCalendarWeek({
          path: { year, calendarWeek },
        })
      ),
    queryKey: ['/projects/calendar/', year, calendarWeek],
  });
